module.exports = __webpack_public_path__ + "static/hve_coul-ff92d37da4105b6940d0fbe28a09f7c4.png";